"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processMarkdown = void 0;
const marked_1 = require("marked");
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const forEach_1 = __importDefault(require("lodash/forEach"));
const keys_1 = __importDefault(require("lodash/keys"));
const includes_1 = __importDefault(require("lodash/includes"));
const config_1 = require("./config");
const processMarkdown = ({ source, headingsStartFrom, rendererMethods, whitelist, inline, }) => {
    if (!source) {
        return null;
    }
    const renderer = new marked_1.marked.Renderer();
    renderer.heading = (text, level) => {
        return `
      <h${headingsStartFrom || level}>${text}</h${headingsStartFrom || level}>
    `;
    };
    /** Custom renderer methods */
    if (!(0, isEmpty_1.default)(rendererMethods)) {
        (0, forEach_1.default)(rendererMethods, (value, key) => {
            renderer[key] = value;
        });
    }
    /** Whitelist */
    if (!(0, isEmpty_1.default)(whitelist)) {
        (0, forEach_1.default)(config_1.allRendererMethods, (method) => {
            if (!(0, includes_1.default)(whitelist, method)) {
                renderer[method] = (content) => content;
            }
        });
    }
    const sanitizerOptions = {
        allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel', 'data'],
    };
    let markdown = null;
    if (inline) {
        markdown = marked_1.marked.parseInline(source, {
            renderer,
        });
        // allow inline tags only
        sanitizerOptions.allowedTags = (0, keys_1.default)(config_1.allowedInlineTagsAndAttrs);
        sanitizerOptions.allowedAttributes = config_1.allowedInlineTagsAndAttrs;
    }
    else {
        // allow both inline and block level tags
        sanitizerOptions.allowedTags = [
            ...(0, keys_1.default)(config_1.allowedInlineTagsAndAttrs),
            ...(0, keys_1.default)(config_1.allowedBlockTagsAndAttrs),
        ];
        sanitizerOptions.allowedAttributes = Object.assign(Object.assign({}, config_1.allowedInlineTagsAndAttrs), config_1.allowedBlockTagsAndAttrs);
        markdown = marked_1.marked.parse(source, {
            renderer,
        });
    }
    return (0, sanitize_html_1.default)(markdown, sanitizerOptions);
};
exports.processMarkdown = processMarkdown;
//# sourceMappingURL=ProcessMarkdown.js.map